<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dataTableSearch">
          <template v-slot:next>
            <el-button icon="el-icon-plus" @click="$router.push('/customer/form')">新增</el-button>
          </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :editable="false"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="subDelete(scope.row.id)"
              >确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable"
import DynamicSearch from "@/components/DynamicSearch"
import DataTableMixin from "@/mixins/DataTableMixin"
import { deleteCustomerById } from "@/api/basic/customer"

export default {
  name: "Customer",
  mixins: [DataTableMixin],
  components: {
    DynamicSearch
  },
  created() {
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  data() {
    return {
      tableHead: [
        {
          label: "客户代码",
          prop: "code",
          query: {
            type: "input"
          }
        },
        {
          label: "客户法定名称",
          prop: "name",
          query: {
            type: "input"
          }
        },
        // {
        //   label: "客户注册省",
        //   prop: "registeredProvince"
        // },
        // {
        //   label: "客户注册市",
        //   prop: "registeredCity"
        // },
        {
          label: "客户详细地址",
          prop: "detailedAddress"
        },
        {
          label: "客户电话",
          prop: "phone"
        },
        {
          label: "客户邮编",
          prop: "email"
        },
        {
          label: "客户传真",
          prop: "fax"
        },
        {
          label: "客户类型",
          prop: "customerType"
        },
        {
          label: "行业",
          prop: "industry.name"
        },
        // {
        //   label: "母公司",
        //   prop: "customer.name"
        // }
      ],
    };
  },
  methods: {
    dataTableBeforeInit() {
      this._url = "/customer"
      const params = { page: this.page, size: this.offset }
      this._params = Object.assign(params, this._query)
      return true
    },
    subDelete(id) {
      deleteCustomerById(id).then(res => {
        this.dataTableInit()
        this.$notify({
          title: "删除成功",
          type: "success",
          duration: 2500
        })
      })
    },
    edit(row) {
      this.$router.push(`/customer/form?id=${row.id}`)
    },
  }
};
</script>

<style scoped lang="scss">
</style>
